<template>
  <div
    class="header-profile"
    @click="openLogoutModal"
  >
    <div
      v-if="user"
      class="header-profile__wrapp"
    >
      <div class="header-profile__avatar">
        <img
          v-if="avatarUrl"
          class="header-profile__avatar-img"
          :src="avatarUrl"
        />
      </div>
      <HeaderProfilePopup class="header-profile__popup" />
    </div>
    <BaseButton
      v-else
      class="header-profile__button"
      tag="button"
      aria-label="Войти в профиль"
      @click="openAuth"
    >
      <SvgAsset
        class="header-profile__button-icon"
        :content="profileSvg"
      />
    </BaseButton>
    <Shutter
      :active="isLogoutShutterShowed"
      hide-breakpoint="big-tablet"
      @close="isLogoutShutterShowed = false"
    >
      <button
        class="logout__button"
        @click="logout"
      >
        <SvgAsset
          class="logout__icon"
          :content="logoutSvg"
        />
        <span class="logout__title">Выйти</span>
      </button>
    </Shutter>
  </div>
</template>

<script lang="ts">
  import HeaderProfilePopup from '~/components/TheHeader/Profile/HeaderProfilePopup.vue';
  import BaseButton from '~/components/BaseComponents/BaseButton.vue';
  import { useAuthRedirect } from '@devhacker/shared/features/auth/utils/authRedirect';
  import { useUserStore } from '~/features/user/store';
  import { useWindowStore } from '~/store/window';
  import SvgAsset from '@devhacker/shared/components/SvgAsset.vue';
  import logoutSvg from '@/assets/images/svg/logout.svg?raw';
  import profileSvg from '~/assets/images/svg/profile.svg?raw';
  import Shutter from '@devhacker/shared/components/Shutter.vue';
  import { useAuthService } from '~/features/auth/service';

  export default defineNuxtComponent({
    name: 'HeaderProfile',

    components: {
      Shutter,
      SvgAsset,
      BaseButton,
      HeaderProfilePopup,
    },

    inject: {
      // Категория в которой происходит событие
      // Для аналитики
      eventCategory: {
        default() {
          return () => '';
        },
      },
    },

    data() {
      return {
        isLogoutShutterShowed: false,
      };
    },

    computed: {
      profileSvg: () => profileSvg,
      logoutSvg: () => logoutSvg,

      user() {
        return useUserStore().userData;
      },

      avatarUrl(): string | null {
        const avatars = this.user?.avatars ?? [];
        return (
          avatars.find((avatar) => avatar.size === 'm')?.url ??
          avatars.find((avatar) => avatar.size === 's')?.url ??
          null
        );
      },

      windowWidth() {
        return useWindowStore().windowWidth;
      },
    },

    methods: {
      openAuth() {
        useAuthRedirect().login();
        this.sendAnalytics();
      },

      // Функция для отправки аналитики клика хедера профиля
      sendAnalytics() {
        this.$sendYandexMetrika({
          level1: 'Клик_Хедер_Профиль_Гость',
        });
      },

      async logout() {
        const authService = useAuthService();
        await authService.logout();
        this.isLogoutShutterShowed = false;
      },

      openLogoutModal() {
        if (this.windowWidth <= 1024 && this.user) {
          this.isLogoutShutterShowed = true;
        }
      },
    },
  });
</script>

<style lang="scss" scoped>
  @use '@/components/TheHeader/styles/TheHeader.variables' as *;

  .header-profile {
    position: relative;

    &__avatar {
      max-width: $headerHeight;
      max-height: $headerHeight;

      overflow: hidden;
      padding: $spacing-2;

      &-img {
        width: 100%;
        border-radius: 50%;
        display: block;
        object-fit: cover;
      }
    }

    @include hover {
      .header-profile__popup {
        opacity: 1;
        pointer-events: all;
      }
    }

    &__popup {
      position: absolute;
      right: 0;
      z-index: 5;
      bottom: 0;
      transform: translateY(100%);
      opacity: 0;
      transition: opacity 0.3s ease;
      pointer-events: none;
    }

    &__button {
      width: 48px;
      height: 48px;
      display: flex;
      align-items: center;
      justify-content: center;

      &-icon {
        width: 24px;
        height: 24px;
        color: $icon-color--1;
      }
    }
  }

  .logout {
    &__button {
      padding: $spacing-4 $spacing-4 $spacing-5;
      display: flex;
      align-items: center;
    }
    &__icon {
      width: 24px;
      height: 24px;
      display: block;
      margin-right: $spacing-2;
    }
    &__icon {
      display: block;
      color: $default-color--1;
    }
    &__title {
      font-family: $text-font--1;
      font-weight: 500;
      @include normalText;
      color: $default-color--1;
    }
  }
</style>
